/**
 * Module dependencies.
 */

import { FormList } from 'app/components/organisms/crud/form-types';
import { requiredRule } from 'app/core/utils/field-rules';
import { usePaginatedCrudRequest } from 'app/hooks/app-requests/crud/use-paginated-crud-request';
import { User } from 'app/types/user';
import { TFunction } from 'react-i18next';

/**
 * Left.
 */

const left = (translate: TFunction, type: 'add' | 'edit'): FormList => [
  {
    type: 'selectField',
    name: 'phoneNumber',
    disabled: type === 'edit',
    showSearch: true,
    allowClear: true,
    rules: requiredRule(translate),
    label: translate('common.labels.user'),
    paginated: { enabled: true, pageSize: 50 },
    options: {
      hook: usePaginatedCrudRequest as any,
      hookProps: (_values: any, _params: any, options: any) => {
        const searchValue = options?.searchValue?.trim();
        return [
          {
            key: ['users-paginated', searchValue || ''],
            endpoint: 'users' as any,
            options: {
              ...(searchValue ? { search: searchValue } : {})
            },
            pageSize: 50
          }
        ];
      },
      normalize: (items: User[]) => {
        console.log(items);
        if (!items || !Array.isArray(items)) {
          return [];
        }
        return items
          .filter(item => item && item.id && item.phoneNumber)
          .map(item => ({
            value: item.phoneNumber,
            label: item.name ?? item.email ?? item.phoneNumber,
            searchValue: item.name
          }));
      }
    }
  },
  {
    type: 'phoneNumberField',
    disabled: true,
    name: 'phoneNumber',
    label: translate('common.labels.phoneNumber'),
    defaultDialCode: 'PT',
    rules: undefined,
    parseValue: (value: string) => {
      if (!value) return null;

      const match = value.match(/^\+(\d{1,4})(.+)$/);

      if (match) {
        return { dialCode: match[1], phone: match[2] };
      }

      return { dialCode: '351', phone: value };
    }
  },
  {
    type: 'selectField',
    name: 'status',
    label: translate('common.labels.status'),
    rules: requiredRule(translate),
    options: [
      {
        value: 'created',
        label: String(translate('common.labels.statusLabels.created'))
      },
      {
        value: 'pending',
        label: String(translate('common.labels.statusLabels.pending'))
      },
      {
        value: 'approved',
        label: String(translate('common.labels.statusLabels.approved'))
      },
      {
        value: 'userRevoked',
        label: String(translate('common.labels.statusLabels.userRevoked'))
      },
      {
        value: 'pharmacyRevoked',
        label: String(translate('common.labels.statusLabels.pharmacyRevoked'))
      }
    ]
  },
  {
    type: 'inputField',
    name: 'externalId',
    label: translate('common.labels.externalId'),
    rules: undefined
  }
];

/**
 * Right.
 */

const right = (translate: TFunction): FormList => [
  {
    type: 'inputField',
    name: 'createdAt',
    disabled: true,
    label: translate('common.labels.createdAt'),
    rules: undefined
  },
  {
    type: 'inputField',
    name: 'updatedAt',
    disabled: true,
    label: translate('common.labels.updatedAt'),
    rules: undefined
  }
];

/**
 * Export `formFields`.
 */

export const formFields = (translate: TFunction, type: 'add' | 'edit'): FormList => [
  {
    type: 'columns',
    gutter: 40,
    name: 'mainWire',
    columns: [
      {
        column: 18,
        children: left(translate, type)
      },
      {
        column: 6,
        children: right(translate)
      }
    ]
  }
];
